import * as React from 'react';

const copyIcon = (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.3335 14.1666V15.8333C3.3335 16.2753 3.50909 16.6993 3.82165 17.0118C4.13421 17.3244 4.55814 17.5 5.00016 17.5H15.0002C15.4422 17.5 15.8661 17.3244 16.1787 17.0118C16.4912 16.6993 16.6668 16.2753 16.6668 15.8333V14.1666M5.8335 9.16665L10.0002 13.3333M10.0002 13.3333L14.1668 9.16665M10.0002 13.3333V3.33331" stroke="#B1BCCF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);

export default copyIcon;
